import { STEPS, FILENAMES } from '@/shared/constants';
import { ICourse } from '@/shared/ICourse';
import { WorkflowTextService } from '@/shared/WorkflowTextService';
import { CourseFileService } from './CourseFileService';
import { PdfService } from './PdfService';
import { CourseModuleStorageService } from './CourseModuleStorageService';
import { formatDate, formatFileDate } from '@/shared/parse';

export class CourseAmendmentService {

  public static async putCourseAmendment(course: ICourse, data: any) {
    const courseId = course.id;
    const fileName = `${STEPS.STEP1}/${FILENAMES.RESULTS}`;

    const module = await CourseModuleStorageService.getCourseModule(courseId, STEPS.STEP1, 'view', true);
    const results = module.results || {};
    const amended = { ...results, ...data };

    const now = new Date();
    const date = formatFileDate(now);

    await CourseFileService.renameFile(courseId, STEPS.STEP1, FILENAMES.RESULTS, 
      `_backup_${date}${FILENAMES.RESULTS}`, 'Results before amendment on ' + formatDate(now));

    await CourseFileService.putJsonFile(courseId, fileName, amended);

    const resultsPdfFileName = WorkflowTextService.getPdfFileName(course.folderName, STEPS.STEP1, false);
    const resultsPdfFileTitle = WorkflowTextService.getPdfFileTitle(STEPS.STEP1, false);

    await CourseFileService.renameFile(courseId, STEPS.STEP1, resultsPdfFileName, 
      `_backup_${date}_${resultsPdfFileName}`, `${resultsPdfFileTitle} before amendment on ${formatDate(now)}`);

    const pdf = await PdfService.generateSurveyPdf(course.coursePlatformVersion, module.results_template, amended);
    await CourseFileService.uploadFiles(courseId, STEPS.STEP1, [new File([pdf], resultsPdfFileName!)], resultsPdfFileTitle, 'replace');

    await CourseFileService.renameFile(courseId, STEPS.COMPLETED, FILENAMES.RESULTS, 
      `_backup_${date}${FILENAMES.RESULTS}`, `Course Amendmnt on ${formatDate(now)}`);
  }
}